/**
 * This enum denotes the account type of the user.
 *
 * Please keep these values in range of 0-5 as they are used in IRIS.
 * To use more than this range, also ensure on updating the value of "accntType" realtime signal for
 * "OWA Mini New Users Onboarding" surface, by working with IRIS team.
 */
export enum AccountType {
    NotSupported = '0',
    ConsumerAccount = '1',
    ConsumerPremium = '2', //Not used anywhere
    EnterpriseAccount = '3',
}
